import lazyScreen from './utils/lazyScreen';
import React from 'react';
import { AntConst } from 'ante-react-kit';
const HomePage = lazyScreen(() => import('./screens/Home/index.js'), 'screens/Home/index.js');
const AROrder = lazyScreen(() => import('./screens/AROrder/index.js'), 'screens/AROrder/index.js');
const ARServeCooking = lazyScreen(() => import('./screens/ARServeCooking/index.js'), 'screens/ARServeCooking/index.js');
const ARServeDelivery = lazyScreen(() => import('./screens/ARServeDelivery/index.js'), 'screens/ARServeDelivery/index.js');
// import ARServeService from './screens/ARServeService';
// import ICIssue from './screens/ICIssue';
// import LGTransport from './screens/LGTransport';
// import ARAppointment from './screens/ARAppointment';
const HRWorkingAttendance = lazyScreen(() => import('./screens/HRWorkingAttendance/index.js'), 'screens/HRWorkingAttendance/index.js');
const AROrderBilling = lazyScreen(() => import('./screens/AROrderBilling/index.js'), 'screens/AROrderBilling/index.js');
const AROrderGoodCounter = lazyScreen(() => import('./screens/AROrderGoodCounter/index.js'), 'screens/AROrderGoodCounter/index.js');
const POSCashBook = lazyScreen(() => import('./pages/pos/POSCashBook/index.js'), 'pages/pos/POSCashBook/index.js');


// Dispatch /pos/AROrder → AROrderGoodCounter cho ngành Commodity-*, AROrder cho phần còn lại.
// Đọc business_industry từ localStorage session-info (đã được lưu ngay sau login).
function AROrderPOSDispatch(props) {
    var industry = '';
    try {
        var raw = localStorage.getItem(AntConst.System_Code + '-session-info');
        if (raw) industry = (JSON.parse(raw) || {}).business_industry || '';
    } catch (e) { /* ignore */ }
    var Comp = (typeof industry === 'string' && industry.indexOf('Commodity') === 0)
        ? AROrderGoodCounter
        : AROrder;
    return React.createElement(Comp, props);
}

// The dispatcher itself has no metadata reads; both children preload theirs.
AROrderPOSDispatch.anteConfigLazy = true;

export default [
    {
        path: '/pos/home',
        component: HomePage
    },
    {
        path: '/pos/AROrder',
        component: AROrderPOSDispatch
    },
    {
        path: '/pos/AROrder/:code',
        component: AROrderPOSDispatch
    },
    {
        path: '/pos/ARServeCooking',
        component: ARServeCooking
    },
    {
        path: '/pos/ARServeDelivery',
        component: ARServeDelivery
    },
    // {
    //     path: '/pos/ARServeService',
    //     component: ARServeService
    // },
    // {
    //     path: '/pos/ICIssue',
    //     component: ICIssue
    // },
    // {
    //     path: '/pos/LGTransport',
    //     component: LGTransport
    // },
    {
        path: '/pos/HRWorkingAttendance',
        component: HRWorkingAttendance
    },
    {
        path: '/pos/AROrderBilling',
        component: AROrderBilling
    },
    {
        path: '/pos/POSCashBook',
        component: POSCashBook
    },
    // {
    //     path: '/pos/ARAppointment',
    //     component: ARAppointment
    // },
    // {
    //     path: '/pos/ARAppointment/:code',
    //     component: ARAppointment
    // }
];
